import React from 'react';
import { FormPrevious } from 'grommet-icons';
import propTypes from 'prop-types';
import { Anchor, Box, Button, Text } from '../element';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactGA from 'react-ga';
import {
  GA_CATEGORY_BUTTON_NAV,
  GA_CATEGORY_MODEL,
  GA_ACTION_CLICKED,
  GA_ACTION_CHOOSE,
  GA_LABEL_CONTINUE,
  GA_LABEL_BACK,
  PRODUCT_ID_PRIMERA,
} from '../../constants';
import { historyPush } from '../../utils/withPath';
import { getValueFromUrl } from '../../utils/eventTracker';

const PrevButton = (props) => {
  const { t } = useTranslation();
  const { history, prevPage, location, pageName } = props;
  const handleClick = () => {
    ReactGA.event({
      category: GA_CATEGORY_BUTTON_NAV,
      action: GA_ACTION_CLICKED,
      label: `${pageName}-${GA_LABEL_BACK}`,
    });
    historyPush(prevPage, location, history);
  };
  // icon color: brand, plain
  return (
    <Anchor
      onClick={handleClick}
      icon={<FormPrevious color="plain" size="medium" />}
      label={
        <Text className="fontSize18 veryDarkGray condensePageNav">
          {t('back')}
        </Text>
      }
      className="marginTop3"
      data-test-id={'back-button'}
    />
  );
};

const NextButton = (props) => {
  const { t } = useTranslation();
  const { history, nextPage, location, pageName } = props;
  let trackingLabel = `${pageName}-${GA_LABEL_CONTINUE}`;
  if (!nextPage) {
    return null;
  }

  const handleClick = () => {
    const model = getValueFromUrl({ location, fieldName: 'model' });
    const product = getValueFromUrl({ location, fieldName: 'product' });
    const pageOpt = getValueFromUrl({ location, fieldName: 'opt' });

    model &&
      ReactGA.event({
        category: GA_CATEGORY_BUTTON_NAV,
        action: GA_ACTION_CLICKED,
        label: `${trackingLabel}`,
      });

    // for selectArrayModel Page , fire two more events
    if (pageName.indexOf('selectArrayModel') !== -1) {
      if (model) {
        // Model selection event
        ReactGA.event({
          category: GA_CATEGORY_MODEL,
          action: GA_ACTION_CHOOSE,
          label: `${model}-${product}`,
        });

        // page-opt selection event
        let pageOptLableBase = 'Integrated';
        switch (product) {
          case PRODUCT_ID_PRIMERA:
            pageOptLableBase = 'Integrated';
            break;
          default:
        }
        pageOpt &&
          ReactGA.event({
            category: `${product}-environment`,
            action: GA_ACTION_CHOOSE,
            label: `${pageOpt}-${pageOptLableBase}`,
          });
      }
    }

    historyPush(nextPage, location, history);
  };
  return (
    <Button
      onClick={handleClick}
      label={
        <Text className="fontSize18" weight="bold">
          {t('continue')}
        </Text>
      }
      color="#00B388"
      primary={true}
      plain={false}
      data-test-id={'continue-button'}
    />
  );
};

const PageNavBar = withRouter((props) => {
  const display = props.hide ? 'none' : 'block';
  const borderSize = props.border !== 'none' ? 'xsmall' : '0';
  return (
    <Box
      style={{ display }}
      direction="column"
      className={`pageNavBar ${props.offset ? 'offset' : ''}`}
    >
      <Box
        direction="row"
        justify="between"
        fill={true}
        border={{ color: '#e6e6e6', side: 'top', size: borderSize }}
        className="paddingTop4"
      >
        <PrevButton {...props} />
        <NextButton {...props} />
      </Box>
    </Box>
  );
});

PageNavBar.propTypes = {
  prevPage: propTypes.string,
  nextPage: propTypes.string,
  pageName: propTypes.string,
};

export default PageNavBar;
